import zod from 'zod';
import { MANDATORY_FIELD } from '../../config/zodConfig';

export const AddressFormSchema = zod.object({
  id: zod.number().optional(),
  name: zod.string().optional(),
  country: zod
    .string({ message: MANDATORY_FIELD })
    .nonempty({ message: MANDATORY_FIELD }),
  state: zod
    .string({ message: MANDATORY_FIELD })
    .nonempty({ message: MANDATORY_FIELD }),
  city: zod
    .string({ message: MANDATORY_FIELD })
    .nonempty({ message: MANDATORY_FIELD }),
  neighborhood: zod
    .string({ message: MANDATORY_FIELD })
    .nonempty({ message: MANDATORY_FIELD }),
  street: zod
    .string({ message: MANDATORY_FIELD })
    .nonempty({ message: MANDATORY_FIELD }),
  addrNumber: zod.string().optional(),
  postalCode: zod
    .string({ message: MANDATORY_FIELD })
    .nonempty({ message: MANDATORY_FIELD }),
  complement: zod.string().optional(),
});
